import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Dashboard from "./pages/Dashboard";
import ErrorBoundary from "./components/ErrorBoundary";
import Layout from "./pages/Layout";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/App.css";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginForm from "./components/LoginForm";
import Category from "./pages/Categories";
import Unit from "./pages/Unit"
import Product from "./pages/Products";
import History from "./pages/History";
import UserMaster from "./pages/UserMaster";
import MyProfile from "./pages/MyProfile";
import Intelligence from "./pages/Intelligence";
import InputPurchases from "./pages/InputPurchases";

const App = () => {
  const { user } = useAuth() || {};
  // console.log("userrrr", user?.user_role);
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route
            path="*"
            element={<Navigate to={user ? "/" : "/login"} replace />}
          />

          {!user && (
            <>
              <Route path="/login" element={<LoginForm />} />
            </>
          )}
          {/* Protected Routes */}
          {user && (
            <Route path="/" element={<ProtectedRoute element={<Layout />} />}>
              <Route index element={<Dashboard />} />
              <Route path="/master-data/categories" element={<Category />} />
              <Route path="/master-data/unit" element={<Unit />} />
              <Route path="/master-data/products" element={<Product />} />
              <Route path="/history" element={<History />} />
               <Route path="/master-data/user-master" element={<UserMaster />} />
               <Route path="/my-profile" element={<MyProfile />} />
               <Route path="/intelligence" element={<Intelligence />} />
              <Route path="/master-data/input-purchases" element={<InputPurchases />} />
              
            </Route>
          )}
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};
export default App;
